import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ForgottenPasswordPageComponent } from './forgottenpassword.component';

const routes: Routes = [{ path: '', component: ForgottenPasswordPageComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ForgottenPasswordPageRoutingModule { }
